{
  "button-bar-for-selected-service": {
    "text": {
      "and-x-more": "and {{nr}} more",
      "duration": "Duration",
      "select-service-hint": "Please select at least one service and desired date time to continue"
    }
  }
}
